const fileInput = document.querySelector('.contact-form__input-file');
const inputFile = document.getElementById('your-file');
const submitButton = document.getElementById('contact-submit');
const maxFileSize = 5 * 1024 * 1024;
const formPopUp = document.querySelector('.form-pop-up');
const closeButton = document.querySelector('.form-pop-up__button');

function handleChange() {
	fileInput.classList.add('visible');
}
if (fileInput) {
	fileInput.addEventListener('change', handleChange);
}

document.addEventListener(
	'wpcf7mailsent',
	() => {
		const formPopUp = document.querySelector('.form-pop-up');
		if (formPopUp) {
			formPopUp.classList.add('active');
		}
	},
	false
);

if (formPopUp) {
	closeButton.addEventListener('click', function () {
		formPopUp.classList.remove('active');
	});
}

if (inputFile) {
	inputFile.addEventListener('change', () => {
		const file = inputFile.files[0];
		if (file) {
			if (file.size > maxFileSize) {
				submitButton.disabled = true;
				console.log('max');
			} else {
				submitButton.disabled = false;
				console.log('min');
			}
		}
	});
}
